export default __webpack_public_path__ + "static/media/Mark-2-HUD-Calibration Widget.d8bfe0f2.jpg";